// extracted by mini-css-extract-plugin
export var borderRadius = "_gk-4";
export var large = "_gk-3";
export var logoContainer = "_gk-0";
export var nameLogo = "_gk-2";
export var small = "_gk-1";